var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M38 30C38 37.732 31.732 44 24 44C16.268 44 10 37.732 10 30C10 22.268 16.268 16 24 16C31.732 16 38 22.268 38 30Z",
    fill: "url(#paint0_linear_13838_160121)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5221 19.6964C17.0156 17.4014 20.3443 16 24.0004 16C27.6565 16 30.9852 17.4014 33.4787 19.6964L39.6205 8.43656C40.7109 6.43744 39.264 4 36.9868 4H30.3541C28.9015 4 27.563 4.78757 26.8575 6.05743L24.0003 11.2003L21.1432 6.05743C20.4377 4.78757 19.0992 4 17.6466 4H11.014C8.73682 4 7.28988 6.43744 8.38032 8.43656L14.5221 19.6964Z",
    fill: "url(#paint1_linear_13838_160121)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0004 34C26.2095 34 28.0004 32.2091 28.0004 30C28.0004 27.7909 26.2095 26 24.0004 26C21.7913 26 20.0004 27.7909 20.0004 30C20.0004 32.2091 21.7913 34 24.0004 34Z",
    fill: "url(#paint2_linear_13838_160121)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13838_160121",
    x1: 16.8923,
    y1: 41.6967,
    x2: 70.3512,
    y2: -17.5139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13838_160121",
    x1: 15.8821,
    y1: 31.5322,
    x2: 72.6732,
    y2: -35.5233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13838_160121",
    x1: 15.8821,
    y1: 31.5322,
    x2: 72.6732,
    y2: -35.5233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.9ac5be58c47b09ebd7a306e6e732b994.svg";
export { ForwardRef as ReactComponent };